import Reveal from "@/components/Reveal";
import { Upload, ScanLine, GitCompare, FileCheck2, Send } from "lucide-react";

const steps = [
  { icon: Upload, n: "01", title: "Import or create", desc: "Bring in existing ADAC XML or build a new compliant file." },
  { icon: ScanLine, n: "02", title: "Validate", desc: "Run schema and rule checks with clear, line-level feedback." },
  { icon: GitCompare, n: "03", title: "Compare & profile", desc: "Diff versions and profile data quality across the dataset." },
  { icon: FileCheck2, n: "04", title: "Report", desc: "Generate an audit-ready report you can share or sign off." },
  { icon: Send, n: "05", title: "Hand over", desc: "Deliver or accept with confidence — first time, every time." },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" id="how-it-works" className="py-24 md:py-32 bg-white border-y border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-16">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">How it works</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            A simple, repeatable workflow from file to handover.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.07} className="relative">
              <div className="rounded-2xl border border-zinc-200 bg-[#F9F9F8] p-7 h-full hover:border-zinc-400 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="h-10 w-10 grid place-items-center bg-[#0033A0] text-white rounded-sm">
                    <s.icon size={20} strokeWidth={1.6} />
                  </span>
                  <span className="font-mono text-sm text-zinc-400">{s.n}</span>
                </div>
                <h3 className="mt-5 font-heading text-base font-medium text-zinc-900">{s.title}</h3>
                <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
